import { Box, Typography, useTheme } from '@mui/material';

import { STATUS_BACKGROUND_MAPPING, STATUS_LABEL_MAPPING } from './constants';

export type StatusDisplayProps = {
  /**
   * @prop {string} id - The id of the status display (optional)
   */
  id?: string;

  /**
   * @prop {string} - The status to display
   */
  status: string;
};

export const StatusDisplay = ({ id, status }: StatusDisplayProps) => {
  const theme = useTheme();

  const statusToLower = status?.toLowerCase();
  const statusLabel = (statusToLower && STATUS_LABEL_MAPPING[statusToLower]) || 'Unknown';
  // TODO: no VDS token for this value — needs designer input (#808080 unknown status fallback)
  const dotBackground = (statusToLower && STATUS_BACKGROUND_MAPPING[statusToLower]) || {
    backgroundColor: '#808080',
  };

  let testId = 'statusDisplay';
  if (id) {
    testId = `${id}-statusDisplay`;
  }

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'left' }}
      data-testid={testId}
    >
      <Box
        sx={{
          width: `${theme.spacing(3)}`,
          height: `${theme.spacing(3)}`,
          borderRadius: `${theme.spacing(1.5)}`,
          ...dotBackground,
          mr: `${theme.spacing(1)}`,
          mb: `${theme.spacing(0.25)}`,
        }}
        data-testid={`statusDot-${statusLabel.replace(/ /g, '_').toLowerCase()}`}
      />
      <Typography
        variant="body2"
        sx={{ whiteSpace: 'nowrap', color: theme.palette.text.primary }}
        data-testid={`label-${statusLabel.replace(/ /g, '_')}`}
      >
        {statusLabel}
      </Typography>
    </Box>
  );
};
